import { useOutlet } from "react-router-dom";
import Section from "../rows/Section";
import { SubBar } from "../base/SubBar";

export default function StaffLayout() {
  const outlet = useOutlet();

  return (
    <>
      <h1>Staff</h1>
      <Section>
        <SubBar
          pages={[
            { label: "總結", path: "/main/staff" },
            // { label: "列表", path: "/supplier/list" },
            { label: "新增", path: "/main/staff/add" },
          ]}
        />
      </Section>
      <Section>{outlet}</Section>
    </>
  );
}
